module.exports = __webpack_public_path__ + "img/star_default.30804ab1.svg";